import * as React from "react";
import {
  Edit,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  DateInput,
  TextInput,
  AutocompleteInput,
  NumberInput,
  required,
  maxValue,
} from "react-admin";
import { COUNT_AIRBAG_MAX, COUNT_BINS_MAX, integerOnly } from "../validators";

const priorityChoises = [
  { id: 0, name: "Basse" },
  { id: 1, name: "Médium" },
  { id: 2, name: "Elevé" },
];

const statusChoices = [
  { id: "IN_PROGRESS", name: "En cours" },
  { id: "COMPLETED", name: "Terminé" },
  { id: "CANCELLED", name: "Annulé" },
];

export const OrderEdit: React.FC = (props) => (
  <Edit {...props} title="Modifier un Bon de Commande">
    <SimpleForm>
      <TextInput source="_id" label="ID interne" disabled />
      <ReferenceInput
        source="client"
        reference="clients"
        label="Client"
        perPage={50}
      >
        <AutocompleteInput
          optionText={(record) => `${record.internalCode} - ${record.name}`}
          fullWidth
          label="Client"
          validate={[required("Le client est requis")]}
          filterToQuery={(q: any) => ({
            filterTree: {
              operator: "or",
              operands: [
                {
                  term: {
                    name: "name",
                    filterType: "like",
                    value: q,
                  },
                },
                {
                  term: {
                    name: "internalCode",
                    filterType: "like",
                    value: q,
                  },
                },
              ],
            },
          })}
        />
      </ReferenceInput>

      <ReferenceInput
        source="provider"
        reference="providers"
        label="Prestataire"
        perPage={50}
      >
        <AutocompleteInput
          optionText={(record) => `${record.internalCode} - ${record.name}`}
          fullWidth
          validate={[required("Le prestataire est requis")]}
          label="Prestataire"
          filterToQuery={(q: any) => ({
            filterTree: {
              operator: "or",
              operands: [
                {
                  term: {
                    name: "name",
                    filterType: "like",
                    value: q,
                  },
                },
                {
                  term: {
                    name: "internalCode",
                    filterType: "like",
                    value: q,
                  },
                },
              ],
            },
          })}
        />
      </ReferenceInput>
      <DateInput
        source="provisionalDate"
        label="Date Prévisionnelle"
        validate={[required("La date prévisionnelle est requise")]}
      />
      <TextInput
        source="orderNumber"
        label="Numero de BDC"
        placeholder="Entrez le numéro de bon de commande"
        validate={[required("Le numéro de bon de commande est requis")]}
      />
      <DateInput source="executionDate" label="Date d'execution" />
      <NumberInput
        source="quantityAirbag"
        label="Quantité d'airbag"
        validate={[
          required("La quantité d'airbag est requise"),
          maxValue(COUNT_AIRBAG_MAX, `Maximum ${COUNT_AIRBAG_MAX}`),
          integerOnly("Doit être un nombre décimal"),
        ]}
      />
      <NumberInput
        source="quantityBin"
        label="Quantité de caisse"
        validate={[
          required("La quantité de caisse est requise"),
          maxValue(COUNT_BINS_MAX, `Maximum ${COUNT_BINS_MAX}`),
          integerOnly("Doit être un nombre décimal"),
        ]}
      />
      <SelectInput
        source="priority"
        label="Priorité"
        choices={priorityChoises}
      />
      <SelectInput source="status" label="Statut" choices={statusChoices} />
    </SimpleForm>
  </Edit>
);
